import type { TranslateFunc } from 'src/components/translate';
import { getColorTranslation } from '../color-variants/utils/colors';
import { getFractalRepresentation } from '../size-variants/utils';
import { getConditionName } from '../../product-conditions/utils';
import type { FilterSelection, IFilter } from 'src/components/price-list/types';
import { FilterType } from 'src/components/price-list/types';
import { ConditionEnum } from '../../product-conditions/types';

export const createNewSelection = (
  variant: string | null,
  variantSelection: FilterSelection
) => {
  if (!variant) {
    return [];
  }
  return variantSelection.includes(variant)
    ? variantSelection.filter((v: string) => v !== variant)
    : [...variantSelection, variant];
};

export const getSelectionsString = (t: TranslateFunc, filter?: IFilter) => {
  const selected = filter?.active ? filter?.selection : null;
  if (!selected?.length) {
    return null;
  }
  const prettified = selected.map(variant => {
    switch (filter?.type) {
      case FilterType.CONDITION:
        return variant === ConditionEnum.USED
          ? getConditionName(variant, t)
          : null;
      case FilterType.VARIANT_SIZE:
        return getFractalRepresentation(variant);
      case FilterType.VARIANT_COLOR:
        return getColorTranslation(t, variant);
      default:
        return variant;
    }
  });
  return prettified.sort().join(', ');
};
